import template from './admin-menu.html';
import controller from './admin-menu.controller';
import './admin-menu.scss';

let AdminMenuComponent = {
  bindings: {
    profiles: '<',
    closingHour: '<'
  },
  template,
  controller
};

export default AdminMenuComponent;



// WEBPACK FOOTER //
// ./src/app/components/admin-menu/admin-menu.component.js